import { motion } from "framer-motion";
import { Play } from "lucide-react";

export default function Watch() {
  return (
    <section id="watch" data-testid="watch-section" className="relative overflow-hidden bg-[#F7F1E6] py-28 text-[#6B5D4F] lg:py-36">
      <motion.div
        className="pointer-events-none absolute -right-32 top-0 h-[26rem] w-[26rem] rounded-full"
        style={{ background: "radial-gradient(circle, rgba(197,160,89,0.18), transparent 65%)" }}
        animate={{ scale: [1, 1.15, 1] }}
        transition={{ duration: 9, repeat: Infinity, ease: "easeInOut" }}
        aria-hidden="true"
      />

      <div className="relative mx-auto max-w-6xl px-6 lg:px-10">
        <motion.p
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.8 }}
          className="flex items-center justify-center gap-3 font-body text-[0.65rem] font-medium uppercase tracking-[0.5em] text-[#C5A059]"
        >
          <Play size={13} strokeWidth={1.5} /> Watch Susan
        </motion.p>
        <motion.h2
          initial={{ opacity: 0, y: 40 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.9, delay: 0.1, ease: [0.76, 0, 0.24, 1] }}
          className="mt-6 text-center font-display2 uppercase leading-[0.88] tracking-[0.01em] text-5xl sm:text-6xl lg:text-7xl"
        >
          See her <span className="font-display normal-case italic tracking-normal text-[#C5A059]">in action.</span>
        </motion.h2>

        <motion.div
          initial={{ opacity: 0, y: 60, scale: 0.97 }}
          whileInView={{ opacity: 1, y: 0, scale: 1 }}
          viewport={{ once: true, margin: "-80px" }}
          transition={{ duration: 1.1, delay: 0.15, ease: [0.76, 0, 0.24, 1] }}
          className="mt-16"
        >
          <div className="border border-[#C5A059]/40 p-3 md:p-4">
            <div data-testid="watch-video-frame" className="relative aspect-video w-full overflow-hidden bg-[#F7F1E6]">
              <iframe
                title="Susan Grau — featured video"
                src="https://www.youtube.com/embed/uBWA0j6XRmQ?rel=0"
                className="absolute inset-0 h-full w-full"
                frameBorder="0"
                allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                allowFullScreen
                loading="lazy"
              />
            </div>
          </div>
          <p className="mt-8 text-center font-script text-2xl text-[#C5A059]/80 md:text-3xl">
            the room always leans in
          </p>
        </motion.div>
      </div>
    </section>
  );
}
